import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';

export const getAnnonces = async (params = "") => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/annonces${params}`;

    // Créer une instance de cache
    const cache = setupCache({
      maxAge: 60 * 60 * 1000,
      debug: false
    });

    // Créer une instance d'Axios avec le cache
    const api = axios.create({
      adapter: cache.adapter
    });

    // L'intercepteur global ajoutera automatiquement le token
    return api.get(ApiUrl).then((response) => response.data);
}

export const createAnnonce = async (annonce) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/annonces`;
    return axios.post(ApiUrl, annonce).then((response) => response.data);
}

export const updateAnnonce = async (id, annonce) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/annonces/${id}`;
    return axios.put(ApiUrl, annonce).then((response) => response.data);
}

export const updateAnnonceImage = async (id, image) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/annonces/${id}/image`;
    const formData = new FormData();
    formData.append('file', image);
    
    return axios.post(ApiUrl, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 30000, // 30 secondes de timeout
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log('Progression upload:', percentCompleted + '%');
        }
    }).then((response) => response.data);
}

export const uploadImageAnnonce = async (id, image) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/annonces/${id}/image`;
    const formData = new FormData();
    formData.append('file', image);
    
    return axios.post(ApiUrl, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => response.data);
}

export const deleteAnnonce = async (id) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/annonces/${id}`;
    return axios.delete(ApiUrl).then((response) => response.data);
}

export const MooveStockage = async (id, newStockageId) => {
  const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/annonces/${id}`;

  return axios.put(ApiUrl, {
    stockage: `api/stockages/${newStockageId}`
  }, {
    headers: {
      'Authorization': `Bearer ` + window.localStorage.getItem('authToken'),
      'Content-Type': 'application/json'
    }
  }).then((response) => response.data)
}